import Sidebar from '../components/layout/Sidebar';
import Header from '../components/layout/Header';
import { ExecStaff } from '../components/widgets/ExecStaff';

export default function ExecStaffPage() {
  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header title="כוח אדם" />
        <main className="flex-1 overflow-y-auto p-6">
          <ExecStaff />
        </main>
      </div>
    </div>
  );
}
